export const getIOSDevice = (model) => {
    let r = '';
    if (model.includes('iPhone')) {
        r = 'iphone';
    } else if (model.includes('iPad')) {
        r = 'ipad';
    }

    return r;
}

export const apiGetDevice = () => {
    try {
        let data = {
            platform: '',
            modal: '',
            uuid: ''
        };

        if (window.cordova) {
            if (window.device) {
                switch(window.device.platform.toLowerCase()) {
                    case 'browser': {
                        data.platform = 'browser';
                        data.modal = window.device.model;
                        data.version = window.device.version;
                        break;
                    }
                    case 'android': {
                        data.platform = 'android';
                        data.manufacturer = window.device.manufacturer;
                        data.modal = window.device.modal;
                        data.uuid = window.device.uuid;
                        break;
                    }
                    case 'ios': {
                        data.platform = 'ios';
                        data.type = getIOSDevice(window.device.modal);
                        data.modal = window.device.modal;
                        data.uuid = window.device.uuid;
                        break;
                    }
                }
            }
        }

        return data;
    } catch (e) {
        throw e
    }        
}

export const apiSetPrevPageDetails = (data) => {
    try {
        return data;
    } catch (e) {
        throw e
    }        
}